<h2>Textarea Basic Examples</h2>

<div class="input-grid">
	<div class="input-column">
		<span class="label">Textarea solo</span>
		<app-textarea
			[formControl]="textareaControl"
			placeholder="Enter text..."
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'textareaControl', placeholder: 'Enter text...'})" />
	</div>

	<div class="input-column">
		<span class="label">Con label</span>
		<app-textarea
			[formControl]="textareaControl"
			placeholder="Enter your description..."
			label="Description"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'textareaControl', placeholder: 'Enter your description...', label: 'Description'})" />
	</div>

	<div class="input-column">
		<span class="label">Con helper text</span>
		<app-textarea
			[formControl]="textareaControl"
			placeholder="Enter detailed information..."
			label="Details"
			helperText="Provide as much detail as possible"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'textareaControl', placeholder: 'Enter detailed information...', label: 'Details', helperText: 'Provide as much detail as possible'})" />
	</div>
</div>

<h2>Textarea Sizes</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Large (64px min-height)</span>
		<app-textarea
			[formControl]="textareaControl"
			placeholder="Large textarea for longer content..."
			label="Large Textarea"
			size="large"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'textareaControl', placeholder: 'Large textarea for longer content...', label: 'Large Textarea', size: 'large'})" />
	</div>

	<div class="size-column">
		<span class="label">Medium (56px min-height)</span>
		<app-textarea
			[formControl]="textareaControl"
			placeholder="Medium textarea for moderate content..."
			label="Medium Textarea"
			size="medium"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'textareaControl', placeholder: 'Medium textarea for moderate content...', label: 'Medium Textarea', size: 'medium'})" />
	</div>

	<div class="size-column">
		<span class="label">Small (48px min-height)</span>
		<app-textarea
			[formControl]="textareaControl"
			placeholder="Small textarea for short content..."
			label="Small Textarea"
			size="small"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'textareaControl', placeholder: 'Small textarea for short content...', label: 'Small Textarea', size: 'small'})" />
	</div>
</div>

<h2>Textarea Adaptable (Auto-grow)</h2>
<p class="section-description">Los tamaños adaptables empiezan con la altura del input equivalente y crecen automáticamente hasta 150px máximo.</p>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Adaptable Large (64px inicial)</span>
		<app-textarea
			[formControl]="adaptableLargeControl"
			placeholder="Escribe aquí... el textarea crecerá automáticamente"
			size="adaptable-large"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'adaptableLargeControl', placeholder: 'Escribe aquí...', size: 'adaptable-large'})" />
	</div>

	<div class="size-column">
		<span class="label">Adaptable Medium (56px inicial)</span>
		<app-textarea
			[formControl]="adaptableMediumControl"
			placeholder="Escribe aquí... el textarea crecerá automáticamente"
			size="adaptable-medium"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'adaptableMediumControl', placeholder: 'Escribe aquí...', size: 'adaptable-medium'})" />
	</div>

	<div class="size-column">
		<span class="label">Adaptable Small (48px inicial)</span>
		<app-textarea
			[formControl]="adaptableSmallControl"
			placeholder="Escribe aquí... el textarea crecerá automáticamente"
			size="adaptable-small"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'adaptableSmallControl', placeholder: 'Escribe aquí...', size: 'adaptable-small'})" />
	</div>
</div>

<h2>Textarea con Icono (Leading Icon)</h2>
<p class="section-description">Se puede añadir un botón con icono de Lucide a la izquierda del textarea. Útil para acciones como subir archivos.</p>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Con icono Plus</span>
		<app-textarea
			[formControl]="leadingIconControl"
			placeholder="Escribe aquí..."
			leadingIcon="Plus"
			(leadingIconClick)="onLeadingIconClick()"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'leadingIconControl', placeholder: 'Escribe aquí...', leadingIcon: 'Plus'})" />
	</div>

	<div class="size-column">
		<span class="label">Con icono Paperclip</span>
		<app-textarea
			[formControl]="leadingIconControl"
			placeholder="Adjuntar archivo..."
			leadingIcon="Paperclip"
			(leadingIconClick)="onLeadingIconClick()"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'leadingIconControl', placeholder: 'Adjuntar archivo...', leadingIcon: 'Paperclip'})" />
	</div>

	<div class="size-column">
		<span class="label">Adaptable con icono</span>
		<app-textarea
			[formControl]="leadingIconAdaptableControl"
			placeholder="Textarea adaptable con icono..."
			size="adaptable-large"
			leadingIcon="Plus"
			(leadingIconClick)="onLeadingIconClick()"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'leadingIconAdaptableControl', placeholder: 'Textarea adaptable con icono...', size: 'adaptable-large', leadingIcon: 'Plus'})" />
	</div>
</div>

<h2>Textarea States</h2>

<div class="size-grid">
	<div class="size-column">
		<span class="label">Normal</span>
		<app-textarea
			[formControl]="textareaControl"
			placeholder="Normal textarea..."
			label="Normal State"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'textareaControl', placeholder: 'Normal textarea...', label: 'Normal State'})" />
	</div>

	<div class="size-column">
		<span class="label">Disabled</span>
		<app-textarea
			[formControl]="disabledTextareaControl"
			placeholder="Disabled textarea..."
			label="Disabled State"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'disabledTextareaControl', placeholder: 'Disabled textarea...', label: 'Disabled State', disabled: true})" />
	</div>

	<div class="size-column">
		<span class="label">Error</span>
		<app-textarea
			[formControl]="textareaControl"
			placeholder="Error textarea..."
			label="Error State"
			[error]="true"
			errorMessage="This field is required"
		/>
		<app-ui-code-block [code]="generateCode({formControl: 'textareaControl', placeholder: 'Error textarea...', label: 'Error State', error: true, errorMessage: 'This field is required'})" />
	</div>
</div>
